import * as moment from "moment";

const mixpanel = require("mixpanel-browser");

class MxpEvent {
	time: moment.Moment;

	constructor() {
		this.time = moment();
	}
}

export class MxpContactCreation extends MxpEvent {
	success() {
		const mxData = {
			"Contact creation duration": moment.duration(moment().diff(this.time)).asSeconds(),
			"Result": "Succeed"
		};
		mixpanel.track("Contact creation", mxData);
	}

	failure() {
		const mxData = {
			"Contact creation duration": moment.duration(moment().diff(this.time)).asSeconds(),
			"Result": "Abandoned"
		};
		mixpanel.track("Contact creation", mxData);
	}
}